import { PerPageSelect as BasePerPageSelect } from '@/components/Form';
import { usePerPageConditionAtom } from '@/features/analyze/atoms/pageCondition.atom';
import { INITIAL_PER_PAGE } from '@/features/analyze/constants';
import { useGetAnalyzeMethod } from '@/features/analyze/hooks/useGetAnalyzeMethod';
import type { AnalyzeMethod } from '@/features/analyze/types';

const buildOptions = (step: number) =>
  Array.from({ length: 10 }, (_, index) => (index + 1) * step);

const PER_PAGE_SETS: Record<AnalyzeMethod, number[]> = {
  search: buildOptions(10),
  treemap: buildOptions(50),
  transition: buildOptions(10),
};

export const PerPageSelect = () => {
  const [perPage, setPerPage] = usePerPageConditionAtom();
  const analyzeMethod = useGetAnalyzeMethod();

  if (!analyzeMethod) return null;

  const currentValue = perPage ?? INITIAL_PER_PAGE[analyzeMethod];

  return (
    <BasePerPageSelect
      value={currentValue}
      onChange={(value) => {
        setPerPage(value);
      }}
      options={PER_PAGE_SETS[analyzeMethod]}
    />
  );
};
